<template>
  <div class="login-container">
    <div class="login-form">
      <h2>Вход в систему определения зданий по материалам контроля</h2>
      <br>
      <br>

      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label>Логин:</label>
          <input v-model="username" type="text" required>
        </div>
        <div class="form-group">
          <label>Пароль:</label>
          <input v-model="password" type="password" required>
        </div>
        <button type="submit" class="login-btn">Войти</button>
      </form>
      
      <div class="test-accounts">
        <h4>Тестовые аккаунты:</h4>
        <p>Админ: admin / admin123</p>
        <p>Пользователь: user / user123</p>
      </div>
      <div class="test-accounts">
        <h2>Задача 10. </h2>
        <h2>Решение команды: Easy-sat.ru team</h2>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useRouter } from 'vue-router';

export default {
  name: 'Login',
  
  setup() {
    const username = ref('');
    const password = ref('');
    const auth = useAuthStore();
    const router = useRouter();

    const handleLogin = () => {
      if (auth.login(username.value, password.value)) {
        router.push('/map');
      } else {
        alert('Неверные учетные данные!');
      }
    };

    return {
      username,
      password,
      handleLogin
    };
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #510868;
}

.login-form {
  background: rgb(255, 255, 255);
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 600px;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.form-group input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #bdc3c7;
  border-radius: 4px;
}

.login-btn {
  width: 100%;
  background: #510868;
  color: white;
  border: none;
  padding: 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.test-accounts {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #ecf0f1;
  font-size: 0.9rem;
}
</style>